<div class="filter-text vox-input-group vox-input-group_dense">
  <input
    [placeholder]="placeholder"
    type="text"
    class="filter-text__input vox-text-field"
    [ngModel]="value"
    (input)="onChangeValue($event)" />
</div>
